import { render, staticRenderFns } from "./giftcomponent.vue?vue&type=template&id=7e7f1932&"
import script from "./giftcomponent.vue?vue&type=script&lang=js&"
export * from "./giftcomponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports